export default "__VITE_ASSET__WV0MDjBC__"